import { NotificationTypes } from "./actionTypes";

export const getNotificationList = (lazyState: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_LIST_LOADING,
      lazyState,
    };
  };
  
  
  export const getNotificationListSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_LIST_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationListError = (error: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_LIST_ERROR,
      payload: error,
    };
  };

export const getNotificationStatus = () => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_STATUS_LOADING,
    };
  };
  
  
  export const getNotificationStatusSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_STATUS_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationStatusError = (error: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_STATUS_ERROR,
      payload: error,
    };
  };
export const getNotificationById = (id:any) => {
    return {
      type: NotificationTypes.GET_BY_ID_NOTIFICATION_LOADING,
      id:id
    };
  };
  
  
  export const getNotificationByIdSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_BY_ID_NOTIFICATION_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationByIdError = (error: any) => {
    return {
      type: NotificationTypes.GET_BY_ID_NOTIFICATION_ERROR,
      payload: error,
    };
  };


  export const clearNotificationMessage = () => {
    return {
      type: NotificationTypes.CLEAR_NOTIFICATION_MESSAGE,
    };
  };

  export const getNotification = () => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_LOADING,
    };
  };
  
  
  export const getNotificationSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationError = (error: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_ERROR,
      payload: error,
    };
  };

  export const getNotificationCount = () => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_COUNT_LOADING,
    };
  };
  
  
  export const getNotificationCountSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_COUNT_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationCountError = (error: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_COUNT_ERROR,
      payload: error,
    };
  };

  export const closeNotification = (id:any) => {
    return {
      type: NotificationTypes.CLOSE_NOTIFICATION_LOADING,
      payload:id
    };
  };
  
  
  export const closeNotificationSuccess = (payload: any) => {
    return {
      type: NotificationTypes.CLOSE_NOTIFICATION_SUCCESS,
      payload: payload,
    };
  };
  
  export const closeNotificationError = (error: any) => {
    return {
      type: NotificationTypes.CLOSE_NOTIFICATION_ERROR,
      payload: error,
    };
  };

  export const closeAllNotification = () => {
    return {
      type: NotificationTypes.CLOSE_ALL_NOTIFICATION_LOADING,
    };
  };
  
  
  export const closeAllNotificationSuccess = (payload: any) => {
    return {
      type: NotificationTypes.CLOSE_ALL_NOTIFICATION_SUCCESS,
      payload: payload,
    };
  };
  
  export const closeAllNotificationError = (error: any) => {
    return {
      type: NotificationTypes.CLOSE_ALL_NOTIFICATION_ERROR,
      payload: error,
    };
  };

  export const getNotificationConfig = () => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_CONFIG_LOADING,
    };
  };
  
  
  export const getNotificationConfigSuccess = (payload: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_CONFIG_SUCCESS,
      payload: payload,
    };
  };
  
  export const getNotificationConfigError = (error: any) => {
    return {
      type: NotificationTypes.GET_NOTIFICATION_CONFIG_ERROR,
      payload: error,
    };
  };

  export const postNotificationConfig = (payload:any) => {
    return {
      type: NotificationTypes.POST_NOTIFICATION_CONFIG_LOADING,
      payload
    };
  };
  
  
  export const postNotificationConfigSuccess = (payload: any) => {
    return {
      type: NotificationTypes.POST_NOTIFICATION_CONFIG_SUCCESS,
      payload: payload,
    };
  };
  
  export const postNotificationConfigError = (error: any) => {
    return {
      type: NotificationTypes.POST_NOTIFICATION_CONFIG_ERROR,
      payload: error,
    };
  };

  
  export const clearNotificationConfig = () => {
    return {
      type: NotificationTypes.CLEAR_NOTIFICATION_CONFIG,
    };
  };
  